module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_7005.398f92a3.png";